import { SET_DYNAMIC_BREADCRUMS, SET_FEATURES, SET_VIRUS_SCAN_STATUS } from '../actionTypes/configurationActionTypes';
import { ConfigState } from '../types/ConfigState';

const initialState: ConfigState = {
  dynamicBreadcrumValues: [],
  features: {
    fileEditing: false,
    contactsInSendEmail: false,
    formConfigurations: false,
    aiTagging: false,
    bulkDocumentCreation: false,
    internalAIAssistant: false,
    docuSignSigning: false,
  },
  virusScanEnabled: false,
};

export const configurationReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_DYNAMIC_BREADCRUMS:
      return { ...state, dynamicBreadcrumValues: action.payload };
    case SET_FEATURES:
      return { ...state, features: action.payload };
    case SET_VIRUS_SCAN_STATUS:
      return { ...state, virusScanEnabled: action.payload };
    default:
      return state;
  }
};
